import React, { FC, useEffect, useState } from 'react';
import { ResumeProaPresenter } from '@presenters/screens/resume-proa.presenter';
import AEAGrid from '../../../ui/aea-grid/aea-grid';
import styles from './resume-proa.module.scss';

const ResumeProa: FC<any> = () => {

    const [dataColumns, setDataColumns] = useState(null);

    const presenter = new ResumeProaPresenter({
        state: {
            dataColumns,
            setDataColumns
        }
    });

    useEffect(() => {        
        presenter.getAllProaSummary();
        presenter.getAllColumnsDefinitions();
        presenter.resetForm();
    }, []);

    return (
        <div>
            <div className={styles.mssUpdate}>{presenter.lastUpdateDate}</div>
            <AEAGrid
                newUrl="/proyecta/presupuesto/new"
                dataGridOptions={presenter.options}>
            </AEAGrid>
        </div>
    )
}

export default ResumeProa;